import React, { useState } from "react";
import { MediumFont } from "../common/Style";
import { registerSBS } from "../../store/reducers/authReducer";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const COLORS = {
  accent: "#5045c2",
  accentLight: "#7a6bdd",
  text: "#1e1a38",
  textSecondary: "#4a4569",
  border: "#ddd6f0",
  heroDark: "#0f0c29",
  heroGradient:
    "linear-gradient(180deg, #0f0c29 0%, #302b63 38%, #24243e 100%)",
};

/** תגובת registerSBS: השרת שולח res.send(password) — axios מחזיר מחרוזת; Redux שומר ב-action.payload ישירות */
const passwordFromRegisterSbsPayload = (payload) => {
  if (payload == null) return "";
  if (typeof payload === "object" && payload.error != null) return "";
  if (typeof payload === "string" || typeof payload === "number")
    return String(payload);
  if (typeof payload?.data === "string" || typeof payload?.data === "number")
    return String(payload.data);
  if (payload?.data != null) return String(payload.data);
  if (payload?.password != null) return String(payload.password);
  return "";
};

const Register = ({ selectedPackage, onRegisterSuccess }) => {
  const dispatch = useDispatch();

  const [registerForm, setRegisterForm] = useState({
    phone: "",
    date: "",
    eventType: "wedding",
  });

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    const body = {
      ...registerForm,
      date: new Date(registerForm.date),
      eventType: registerForm.eventType === "wedding" ? true : false,
      deal: parseFloat(selectedPackage.priceLabel.replace("₪ לרשומה", "")),
    };
    dispatch(registerSBS(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        const phoneTrimmed = registerForm.phone.trim();
        const serverPassword = passwordFromRegisterSbsPayload(res.payload);
        setRegisterForm({ phone: "", date: "", eventType: "wedding" });
        if (typeof onRegisterSuccess === "function") {
          onRegisterSuccess({
            phone: phoneTrimmed,
            password: serverPassword,
          });
        }
      } else toast.error(res.payload?.error);
    });
  };

  const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    fontSize: 16,
    fontFamily: "hebM",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 12,
    background: "#ffffff",
    color: COLORS.text,
    outline: "none",
    boxSizing: "border-box",
  };

  const labelStyle = {
    display: "block",
    fontSize: 14,
    fontFamily: "hebM",
    color: COLORS.textSecondary,
    marginBottom: 8,
  };

  return (
    <form
      onSubmit={handleRegisterSubmit}
      onClick={(e) => e.stopPropagation()}
      style={{ width: "100%" }}
    >
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>מספר נייד</label>
        <input
          type="tel"
          placeholder="050XXXXXXX"
          value={registerForm.phone}
          onChange={(e) =>
            setRegisterForm({ ...registerForm, phone: e.target.value })
          }
          required
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>תאריך האירוע</label>
        <input
          type="date"
          value={registerForm.date}
          onChange={(e) =>
            setRegisterForm({
              ...registerForm,
              date: e.target.value,
            })
          }
          required
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ ...labelStyle, marginBottom: 12 }}>סוג האירוע</label>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              border: `1px solid ${
                registerForm.eventType === "wedding"
                  ? COLORS.accent
                  : COLORS.border
              }`,
              background:
                registerForm.eventType === "wedding"
                  ? `${COLORS.accent}10`
                  : "#ffffff",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            <input
              type="radio"
              name="eventType"
              value="wedding"
              checked={registerForm.eventType === "wedding"}
              onChange={(e) =>
                setRegisterForm({
                  ...registerForm,
                  eventType: e.target.value,
                })
              }
              style={{ accentColor: COLORS.accent }}
            />
            <MediumFont style={{ fontSize: 15, color: COLORS.text }}>
              חתונה
            </MediumFont>
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              border: `1px solid ${
                registerForm.eventType === "other"
                  ? COLORS.accent
                  : COLORS.border
              }`,
              background:
                registerForm.eventType === "other"
                  ? `${COLORS.accent}10`
                  : "#ffffff",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            <input
              type="radio"
              name="eventType"
              value="other"
              checked={registerForm.eventType === "other"}
              onChange={(e) =>
                setRegisterForm({
                  ...registerForm,
                  eventType: e.target.value,
                })
              }
              style={{ accentColor: COLORS.accent }}
            />
            <MediumFont style={{ fontSize: 15, color: COLORS.text }}>
              אירוע מסוג אחר
            </MediumFont>
          </label>
        </div>
      </div>

      <button
        type="submit"
        style={{
          width: "100%",
          padding: "14px 20px",
          border: "none",
          borderRadius: 12,
          background: COLORS.heroGradient,
          color: "#ffffff",
          fontSize: 16,
          fontFamily: "hebB",
          cursor: "pointer",
          boxShadow: `0 4px 16px ${COLORS.heroDark}40`,
        }}
      >
        שליחת הרשמה
      </button>
    </form>
  );
};

export default Register;
